/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByConversationUserQueryKind =
  (typeof GroupByConversationUserQueryKind)[keyof typeof GroupByConversationUserQueryKind];

export const GroupByConversationUserQueryKind = {
  conversation_user_query: 'conversation_user_query',
} as const;
